module.exports = __webpack_public_path__ + "static/media/mobileEmpty.e3562b62.png";